var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseText',{staticClass:"month-title"},[_vm._v(" "+_vm._s(_vm.currentYear)+"年度"+_vm._s(_vm.month)+"月号 ")])}
var staticRenderFns = []

export { render, staticRenderFns }